import { render } from "./AposDocLocalePicker.vue?vue&type=template&id=677f7b12&scoped=true"
import script from "./AposDocLocalePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AposDocLocalePicker.vue?vue&type=script&setup=true&lang=js"

import "./AposDocLocalePicker.vue?vue&type=style&index=0&id=677f7b12&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677f7b12"],['__file',"doc-type/ui/apos/components/AposDocLocalePicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "677f7b12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('677f7b12', __exports__)) {
    api.reload('677f7b12', __exports__)
  }
  
  module.hot.accept("./AposDocLocalePicker.vue?vue&type=template&id=677f7b12&scoped=true", () => {
    api.rerender('677f7b12', render)
  })

}


export default __exports__